export const zh_CN: Record<string, any> = {
  pluginName: '大纲树',
};
